import type { ComponentProps } from 'react'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from './CommandModalButton'
import { CommandModalDataFallbackForm } from './CommandModalDataFallbackForm'
import type { ActionButtonProps } from './types'

export const EmployerAgreementCommandModalButtonFallback = (
  props: ActionButtonProps,
) => {
  const { tenantId, employerAgreementId } = useHook(
    'routing.employer.useEmployerAgreementParams',
  )({
    isOptional: true,
  })
  const commandData = props.eventVersionWithCommand?.commandVersion?.commandData

  const actions = useHook(
    'mutators.life.useEmployerAgreementCommandFallbackActions',
  )({
    tenantId: tenantId ?? '',
    employerAgreementId: employerAgreementId ?? '',
    ...props,
  })

  const submit = useVariantAction({
    ...props,
    actions,
  })

  const actionId = `life.${commandData?._type}`

  return props.commandActionVariant === 'create' ? null : (
    <CommandModalButton
      actionId={
        actionId as ComponentProps<typeof CommandModalButton>['actionId']
      }
      // Translations here will be looked at in a later PR: APG2223-3986
      title={commandData?._type ?? ''}
      commandDataForm={CommandModalDataFallbackForm}
      submit={submit}
      {...props}
    />
  )
}
